import React, { useEffect, useMemo } from 'react';
import { useTranslation } from '../context/TranslationContext';
import { useWaItem } from '../context/WaItemContext';
import { AdminDataTab } from '../components';
import { 
  createLocalStorageDataSource, 
  createWaItemsDataSource, 
  createSessionStorageDataSource,
  createRegexpRulesDataSource,
  createRoutingConfigDataSource
} from '../utils/dataSourceFactory';

/**
 * Page d'administration des données dynamiques côté client
 * Permet de surveiller et gérer les données localStorage, waItems, sessionStorage, etc.
 * Taggée LOG_VIEWER pour les traductions
 */
const ClientDataPage = () => {
  const { t, loadPageTranslations } = useTranslation();
  const waItemContext = useWaItem();

  // Créer les sources de données de manière mémorisée
  const dataSources = useMemo(() => [
    createWaItemsDataSource(waItemContext),
    createRegexpRulesDataSource(),
    createRoutingConfigDataSource(),
    createLocalStorageDataSource(/^bel_/, 'LocalStorage (bel_*)'),
    createLocalStorageDataSource(/^wa_/, 'LocalStorage (wa_*)')
  ], [waItemContext]);

  // Charger les traductions pour la page LOG_VIEWER
  useEffect(() => {
    loadPageTranslations('LOG_VIEWER');
  }, [loadPageTranslations]);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="page-container">
        <h1 className="text-2xl font-bold text-gray-900">{t('LOG_VIEWER', 'PAGE_TITLE', 'Données Dynamiques Client')}</h1>
        <p className="text-secondary mb-6">
          {t('LOG_VIEWER', 'PAGE_DESCRIPTION', 'Visualisation et gestion des données dynamiques stockées côté client pour le fonctionnement des algorithmes.')}
        </p>

        {/* Composant unifié pour toutes les sources de données */}
        <AdminDataTab dataSources={dataSources} />
      </div>
    </div>
  );
};

export default ClientDataPage;
